class MeasurementTypes {
    static POINT_ACCESS = 'point';
    static NETWORK_ACCESS = 'network';
    static SECTOR_ACCESS = 'sector';
}

export default MeasurementTypes